import ApplicationAdapter from 'eflex/adapters/application';

export default class OpenProtocolToolAdapter extends ApplicationAdapter {
  pathForType() {
    return 'hardwares';
  }
}
